import React from 'react';

import { Link, MaskedLink } from '../../../components/Link';
import type { TSsoLinks } from 'src/types/THeaderConfig';

type TLoginButtonProps = {
  isLoggedIn: boolean;
  ssoLinks?: TSsoLinks; // optional because ssoLinks comes from useContext (possibly undefined)
  loginTarget: string;
};

const getUrlTarget = (isLoggedIn: boolean, loginTarget: string) => (isLoggedIn ? '' : `target=${loginTarget}`);

export const formatLoginData = (isLoggedIn: boolean, ssoLinks: TSsoLinks, loginTarget: string) => {
  const accessObj = isLoggedIn ? ssoLinks.logout : ssoLinks.login;

  const urlWithQueryParam = (url) => new RegExp(/\?.+=.*/g).test(url);

  const urlTargetParam = getUrlTarget(isLoggedIn, loginTarget);

  const urlWithTarget = urlWithQueryParam(accessObj.url)
    ? `${accessObj.url}&${urlTargetParam}`
    : `${accessObj.url}?${urlTargetParam}`;

  return {
    ...accessObj,
    url: urlTargetParam ? urlWithTarget : accessObj.url,
  };
};

/**
 * Renders either the login or logout button
 */

const LoginButton = ({ isLoggedIn = false, ssoLinks, loginTarget }: TLoginButtonProps): React.JSX.Element => {
  if (!ssoLinks) {
    throw new Error('SSO links are required to render login and logout buttons');
  }

  const { url, role, text } = formatLoginData(isLoggedIn, ssoLinks, loginTarget);

  const LinkComponent = role === 'logout' ? MaskedLink : Link;

  return (
    <li>
      <LinkComponent href={url} data-role={`mymp-${role}`} tabIndex={-1}>
        {text}
      </LinkComponent>
    </li>
  );
};

export default LoginButton;
